/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../../node_modules/@types/typeahead/index.d.ts" />
/// <reference path="../../../node_modules/@types/jquery-mask-plugin/index.d.ts" />
/// <reference path="../CISAddressTypeAhead.ts" />
import { AddressTypeAhead } from "../CISAddressTypeAhead";
import { Utility } from "../Shared/Utility";
export { Utility } from "../Shared/Utility";

export class Validate {

    Initialize(): void {
        this.BindSubmitButtonHandler();
        const cisUrl: string = `${location.protocol}//${location.host}/api/Eligibility/TypeaheadAddress`;
        const typeAhead = new AddressTypeAhead(cisUrl);
        typeAhead.Setup("TypeaheadAddress", "MelissaAddressKey", "UnitNumber");
        const cisValidationTypeCodeValue = $("#CisValidationTypeCode").val() as string;
        this.ShowHideCustomerLookupFields(cisValidationTypeCodeValue);

        if(cisValidationTypeCodeValue != "0" && cisValidationTypeCodeValue)
        {
            this.ShowHideOverrideFields();
        }
        
        this.BindHandlers();

        //getting value from hidden input with ViewBag.AccountNumberMask value
        $("#AccountNumber").mask($("#accountNumberMask").val()!.toString());
    }

    ShowHideCustomerLookupFields(lookupTypeValue: string): void {
        $("#divBillingNumber").hide();
        $("#divTypeaheadAddress").hide();
        $("#divLastName").hide();
        $("#divCompanyName").hide();
        $("#divZipcode").hide();
        $("#divUnit").hide();
        // console.log(lookupTypeValue);
        // debugger;
        switch (lookupTypeValue) {
            //account number and zip code
            case "1":
                $("#divBillingNumber").show();
                $("#divZipcode").show();
                break;
            //address and last name
            case "2": 
                $("#divTypeaheadAddress").show();
                $("#divLastName").show();
                break;
            //address and company name
            case "3": 
                $("#divTypeaheadAddress").show();
                $("#divCompanyName").show();
                break;
            //show overrides
            default:
                $('#divAccountLookup input').val('');
                $('#divAccountLookup').hide();
                $('#divValidationInstructions').hide();
                $('#divOverrideCisValidationFields').show();
            }
    }    

    BindHandlers(): void {
        $("#CisValidationTypeCode").change((() => {
            this.ShowHideCustomerLookupFields($("#CisValidationTypeCode").val() as string);
            this.ResetInputs();
        }));        
        
        $("#OverrideCisValidation").on('click', () => {
            this.ShowHideOverrideFields();  
        });
    }

    ShowHideOverrideFields() {
        if ($("#OverrideCisValidation").is(':checked')) {
            $('#divAccountLookup input:not(#CisValidationTypeCode)').val('');
            $('#divAccountLookup').hide();
            $('#divValidationInstructions').hide();
            $('#divOverrideCisValidationFields').show();
        } else {
            $('#divOverrideCisValidationFields input').val('');
            $('#divOverrideCisValidationFields').hide();
            $('#divAccountLookup').show();
            $('#divValidationInstructions').show();
        }
    }

    ResetInputs(): void {
        $("#AccountNumber").val('');
        $("#CustomerLastName").val('');
        $("#CustomerCompanyName").val('');
        $("#AccountNumber").val('');
        $("#TypeaheadAddress").val('');
        $("#ZipCode").val('');
        $("#UnitNumber").val('');
    }

    BindSubmitButtonHandler(): void {
        ///Continue button handles the "submit" on the page
        ///Make sure only one "click" event is processed.
        ///Note: one() will remove the click handler, so if validation fails, it needs to be reattached.
        $("#submitButton").one('click', (evt) => {
            if ($("#validate-form").valid()) {
                $(evt.target).slideUp();
                $("#cancelButton").slideUp();
                $("#validate-form").trigger("submit");
            } else {
                this.BindSubmitButtonHandler();
            }
        });
    }
}

//DOM
((window: any, document: any) => {
    $(() => {
        var validate = new Validate();
        validate.Initialize();
	});
})(window, document);
